/*
 *  -----------------------------------------------------------------------
 *    <copyright file="grid.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { GridColumnProps } from '@progress/kendo-react-grid';
import _ from 'lodash';
import { unixDateFromUtc, formatDateUTC_DEPRECATED } from 'utils/convertor';

// convert dates in compatible format for grouping, to group just dates without time or to group dates with partial dates
// returns a new settings for grouping and modified array to group
export const prepareForGrouping = (filteredItems: any[], columnsArray: any[], group: any[]) => {
    let grouping;
    let preparedArray = filteredItems;
    if (group) {
        // check if we have in group array date fields
        let dateGroups = [...columnsArray].filter(
            (item: any) => group.findIndex((el: any) => el.field === item.field) >= 0 && item.filter === 'date',
        );
        if (dateGroups.length)
            preparedArray = filteredItems.map((item: any) => {
                dateGroups.forEach((el: any) => {
                    const fields = el.field.indexOf('.') >= 0 ? el.field.split('.') : null;

                    // create new field in compatible format
                    if (fields) {
                        // case when we have nested object in column - field: 'date.time'
                        const { ignore } = _.get(item, fields[0]);
                        item[`_${fields[0]}`] = {
                            [fields[1]]: _.get(item, el.field)
                                ? unixDateFromUtc(_.get(item, el.field), ignore === 1 || ignore === 2)
                                : null,
                        };
                    } else
                        item[`_${el.field}`] = _.get(item, el.field)
                            ? formatDateUTC_DEPRECATED(_.get(item, el.field), true, 'DD-MMM-YYYY')
                            : null;
                });
                return item;
            });
        dateGroups = dateGroups.map((el: any) => ({
            original: el.field,
            field: `_${el.field}`,
        }));
        // pass new field instead of original one
        grouping = group.map((item: any) => ({
            field: dateGroups.find((el: any) => el.original === item.field)?.field ?? item.field,
            dir: item.dir ?? 'asc',
        }));
    }
    return {
        grouping,
        preparedArray,
    };
};

export const compareColumnsByOrderIndex = (column1: GridColumnProps, column2: GridColumnProps) =>
    (column1?.orderIndex || 0) - (column2?.orderIndex || 0);
